module.exports = __webpack_public_path__ + "img/20200625_132201.330bdec5.jpg";